import { useEffect, useState } from 'react';
import format from 'date-fns/format';
import { ICoinNewsAI, ITokenNewsItem } from '@kattana-io/common';
import Text from '../../atoms/Text';
import { timeDistance } from '../../components/DexTrades/formatters';
import { decorate } from './newsFormatters';
import AIBar from './AIBar';

import './styles.scss';

interface IProps {
  news: ITokenNewsItem[]; // TODO: typo
  ai?: ICoinNewsAI;
}

interface INewsItem {
  CreatedAt: string;
}

const ShortNews = (props: IProps) => {
  const { news, ai } = props;
  const [groups, setGroups] = useState<any>({});

  useEffect(() => {
    const hashmap: any = {};
    news.forEach((item: INewsItem) => {
      const { CreatedAt } = item;
      const [date] = CreatedAt.split('T');
      if (hashmap[date]) {
        hashmap[date] = [...hashmap[date], item];
      } else {
        hashmap[date] = [item];
      }
    });
    setGroups(hashmap);
  }, [news]);

  const onNewsItemClicked = (item: any, event: any) => {
    if (event.target.tagName.toLowerCase() !== 'a') {
      window.open(item.Link, '_blank');
    }
  };

  return (
    <div className='miniNews'>
      {ai && <AIBar data={ai} />}
      {Object.keys(groups).map((key: string) => {
        const items = groups[key];
        const formatedDate = format(
          Date.parse(items[0].CreatedAt),
          'dd-MMM-yyyy'
        );

        return (
          <div className='miniNews__group' key={key}>
            <div className='miniNews__group__date'>{formatedDate}</div>
            <div className='miniNews__group__items'>
              {items.map((item: any) => (
                <div
                  key={item.ID}
                  className='miniNews__group__items__item'
                  onClick={(e: any) => onNewsItemClicked(item, e)}
                >
                  <div
                    className='miniNews__group__items__item__text'
                    dangerouslySetInnerHTML={{
                      __html: decorate(item.Text, item.Hash.includes('twit-')),
                    }}
                  />
                  <Text size={12} className='text--grey-600 text--weight-600'>
                    {item.Hash.includes('twit-') ? 'Twitter' : 'Project'} &bull;{' '}
                    {timeDistance(Date.parse(item.CreatedAt))} ago
                  </Text>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ShortNews;
